import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ColumnType } from '../../enums/column-type';
import { ColumnComponentInputs } from '../../interfaces/column-component-inputs';
import { State } from '@progress/kendo-data-query/dist/npm/state';
import { SVGIcon, xIcon, cloudIcon } from '@progress/kendo-svg-icons';
import { finalize } from 'rxjs';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { PlacementHistoryRequest } from '../../interfaces/placement-record';

@Component({
    selector: 'app-placement-history',
    templateUrl: './placement-history.component.html',
    styleUrls: ['./placement-history.component.scss'],
    standalone: false
})
export class PlacementHistoryComponent implements OnInit {
  private readonly rescindedStatusId: number = 10;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Input() studentDetails: string;
  @Input() studentSk: string;
  loadSpinner: boolean = false;
  columnTypeEnum: typeof ColumnType = ColumnType;
  columnDefinitions: ColumnComponentInputs[] = [
    {
      title: 'Status',
      field: 'status',
      columnType: ColumnType.text,
      width: 110,
    },
    {
      title: 'School',
      field: 'schoolName',
      columnType: ColumnType.text,
      width: 300,
    },
    {
      title: 'Admin DBN',
      field: 'schoolDBN',
      columnType: ColumnType.text,
      autoSize: false,
      width: 150,
    },
    {
      title: 'Physical Location',
      field: 'buildingCode',
      columnType: ColumnType.text,
      autoSize: false,
      width: 150,
    },
    {
      title: 'Program',
      field: 'program',
      columnType: ColumnType.text,
      width: 200,
    },
    {
      title: 'Placement Type',
      field: 'placementType',
      columnType: ColumnType.text,
      width: 150,
    },
    {
      title: 'Placement Date',
      field: 'placementDate',
      columnType: ColumnType.dateTime,
      width: 200,
    },
    {
      title: 'School Year',
      field: 'schoolYear',
      columnType: ColumnType.text,
      width: 150,
    },
    {
      title: 'Rescind Reason (if applicable)',
      field: 'rescindReason',
      columnType: ColumnType.text,
      width: 260,
    },
  ];
  xIcon: SVGIcon = xIcon;
  cloudIcon: SVGIcon = cloudIcon;

  initialNestedGridState: State = {
    skip: 0,
    take: 20,
    sort: [{ dir: 'asc', field: 'evaluationName' }],
    group: [],
  };
  loading: boolean;
  placementData: PlacementHistoryRequest[];

  constructor(private dashboardService: DashboardService) {}

  ngOnInit(): void {
    this.getPlacementDetails();
  }

  getPlacementDetails(): void {
    this.loadSpinner = true;
    this.dashboardService
      .getPlacementHistory(this.studentDetails)
      .pipe(finalize(() => (this.loadSpinner = false)))
      .subscribe({
        next: (res: PlacementHistoryRequest[]) => {
          this.placementData = (res ?? []).map((row: PlacementHistoryRequest) => ({
            ...row,
            placementType: row.isSummer ? '12 months' : '10 months',
          }));
        },
        error: () => {
          this.placementData = [];
        },
      });
  }

  isRescindedPlacement(row: PlacementHistoryRequest): boolean {
    return Number(row?.caseActionStatus) === this.rescindedStatusId;
  }

  getPlacementStatus(row: PlacementHistoryRequest): string {
    if (this.isRescindedPlacement(row)) {
      return 'Rescinded';
    }

    return row?.isCurrent ? 'Current' : 'Previous';
  }

  getRescindReason(row: PlacementHistoryRequest): string {
    return row?.rescindReason || '';
  }
}
